export const PERMISSIONS = {
  // Dashboard
  DASHBOARD_VIEW: 'dashboard:read',

  // Doctors
  DOCTORS_VIEW:   'doctors:read',
  DOCTORS_CREATE: 'doctors:create',
  DOCTORS_EDIT:   'doctors:update',
  DOCTORS_DELETE: 'doctors:delete',

  // Patients
  PATIENTS_VIEW:   'patients:read',
  PATIENTS_CREATE: 'patients:create',
  PATIENTS_EDIT:   'patients:update',

  // Appointments
  APPOINTMENTS_VIEW:   'appointments:read',
  APPOINTMENTS_CREATE: 'appointments:create',
  APPOINTMENTS_EDIT:   'appointments:update',

  // Inventory
  INVENTORY_VIEW:   'inventory:read',
  INVENTORY_CREATE: 'inventory:create',
  INVENTORY_EDIT:   'inventory:update',
  INVENTORY_DELETE: 'inventory:delete',

  // Orders
  ORDERS_VIEW:   'orders:read',
  ORDERS_CREATE: 'orders:create',
  ORDERS_EDIT:   'orders:update',

  // Payments
  PAYMENTS_VIEW: 'payments:read',

  // Master Management
  MASTER_VIEW:   'master:read',
  MASTER_CREATE: 'master:create',
  MASTER_EDIT:   'master:update',
  MASTER_DELETE: 'master:delete',

  // Lab Tests
  LAB_TESTS_VIEW:   'lab_tests:read',
  LAB_TESTS_CREATE: 'lab_tests:create',
  LAB_TESTS_EDIT:   'lab_tests:update',
  LAB_TESTS_DELETE: 'lab_tests:delete',

  // Lab Test Categories
  LAB_CATEGORIES_VIEW:   'lab_categories:read',
  LAB_CATEGORIES_CREATE: 'lab_categories:create',
  LAB_CATEGORIES_EDIT:   'lab_categories:update',
  LAB_CATEGORIES_DELETE: 'lab_categories:delete',

  // Lab Bookings
  LAB_BOOKINGS_VIEW:   'lab_bookings:read',
  LAB_BOOKINGS_CREATE: 'lab_bookings:create',
  LAB_BOOKINGS_EDIT:   'lab_bookings:update',

  // Lab Payments
  LAB_PAYMENTS_VIEW: 'lab_payments:read',
  LAB_PAYMENTS_EDIT: 'lab_payments:update',

  // Support Tickets
  SUPPORT_VIEW:   'tickets:read',
  SUPPORT_REPLY:  'tickets:reply',
  SUPPORT_CLOSE:  'tickets:close',

  // Delivery Boys
  DELIVERY_VIEW:   'delivery:read',
  DELIVERY_CREATE: 'delivery:create',
  DELIVERY_EDIT:   'delivery:update',
  DELIVERY_DELETE: 'delivery:delete',

  // Withdraw Requests
  WITHDRAW_VIEW:    'withdrawals:read',
  WITHDRAW_APPROVE: 'withdrawals:update',

  // Deposit Requests
  DEPOSIT_VIEW:    'deposits:read',
  DEPOSIT_APPROVE: 'deposits:update',

  // Settings
  SETTINGS_VIEW: 'settings:read',

  // Prescriptions / Invoices
  PRESCRIPTION_VERIFY: 'prescription:verify',
  INVOICE_VIEW:        'invoice:read',
};
